import CustomLoading from '@/components/custom-loading';
import React, { createContext, useState } from 'react';

type TFullScreenLoadingContext = {
  isLoading: boolean;
  event: {
    setIsLoading: (value: boolean, noBackground?: boolean) => void;
  };
};
export const FullScreenLoadingContext =
  createContext<TFullScreenLoadingContext>({
    isLoading: false,
    event: {
      setIsLoading: () => {},
    },
  });

export function FullLoadingOverlayProvider(props: {
  children?: React.ReactNode;
}) {
  const [isCustomLoading, setIsCustomLoading] = useState<boolean>(false);

  const [isNoBackgroundLoading, setIsNoBackgroundLoading] =
    useState<boolean>(false);
  const setIsLoading = (value: boolean, noBackground?: boolean) => {
    setIsCustomLoading(value);
    setIsNoBackgroundLoading(noBackground ?? false);
  };

  return (
    <FullScreenLoadingContext.Provider
      value={{
        isLoading: isCustomLoading,
        event: {
          setIsLoading,
        },
      }}
    >
      {props.children}
      {isCustomLoading && !isNoBackgroundLoading && (
        <div className="fixed left-0 top-0 size-full bg-slate-100/80 z-[1000]">
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <CustomLoading />
          </div>
        </div>
      )}
      {isCustomLoading && isNoBackgroundLoading && (
        <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <CustomLoading />
        </div>
      )}
    </FullScreenLoadingContext.Provider>
  );
}
